export enum Path {
  root = '/',
  app = '/app',
  auth = '/auth',
  redirect = '/redirect',
  playerPlayground = '/player-playground',

  // auth
  login = '/auth/login',
  register = '/auth/register',
  activateAcc = '/auth/activate-account',
  resetCode = '/auth/reset-code',
  resetPassword = '/auth/reset-password',

  // app
  pulseIntro = '/app/welcome',
  projects = '/app',
  selector = '/app/selector',
  storyboard = '/app/storyboard',
  finalcuts = '/app/finalcuts',
  sharingTikTok = '/app/sharing/tiktok',
}
